// src/config.js
export const API_BASE_URL = "https://oa5bxako8d.execute-api.us-east-1.amazonaws.com/prod";

//=====filter configuration====

export const ACTIVE_FILTERS = {
    'PartyName': true,
    'TotalVotes': true,
    'CandidateName': true,
    'DistrictName': true,
    'PrecinctName': true,
    'Year': true
  };
export const FILTER_CONFIG = {
  'all-candidates': {
    endpoint: '/all-candidates',
    labelKey: 'CandidateName',
    dataKey: 'PartyName',
    validFilters: {
      'name': 'CandidateName',
      'party': 'PartyName',
      'district': 'DistrictName'
    },
    validViz: {
      'table': true,
      'bar': true,
      'pie': true
    }
  },
  'all-votes-by-party': {
    endpoint: '/all-votes-by-party',
    labelKey: 'PartyName',
    dataKey: 'TotalVotes',
    validFilters: {
      'party': 'PartyName',
      'votes': 'TotalVotes'
    },
    validViz: {
      'table': true,
      'bar': true,
      'pie': true,
      'histogram': true
    }
  },
  'all-votes-by-candidate': {
    endpoint: '/all-votes-by-candidate',
    labelKey: 'CandidateName',
    dataKey: 'VoteCount',
    validFilters: {
      'name': 'CandidateName',
      'party': 'PartyName',
      'votes': 'VoteCount'
    },
    validViz: {
      'table': true,
      'bar': true,
      'pie': true
    }
  },
  'candidates-by-party': {
    endpoint: '/candidates-by-party',
    labelKey: 'CandidateName',
    dataKey: 'DistrictName',
    validFilters: {
      'name': 'CandidateName',
      'party': 'PartyName',
      'district': 'DistrictName'
    },
    validViz: {
      'table': true,
      'bar': true
    }
  },
  'votes-by-district': {
    endpoint: '/votes-by-district',
    labelKey: 'DistrictName',
    dataKey: 'TotalVotes',
    validFilters: {
      'district': 'DistrictName',
      'votes': 'TotalVotes',
      'contestant': 'ContestantName'
    },
    validViz: {
      'table': true,
      'bar': true,
      'pie': true
    }
  },
  'votes-by-precinct': {
    endpoint: '/votes-by-precinct',
    labelKey: 'PrecinctName',
    dataKey: 'VoteCount',
    validFilters: {
      'precinct': 'PrecinctName',
      'votes': 'VoteCount',
      'contestant': 'ContestantName'
    },
    validViz: {
      'table': true,
      'bar': true,
      'pie': true,
      'scatterplot': true
    }
  }
};

//===default party colorization===
export const PARTY_COLORS = {
  'Democratic': {
    backgroundColor: 'rgba(0, 0, 255, 0.6)',
    borderColor: 'rgba(0, 0, 255, 1)'
  },
  'Republican': {
    backgroundColor: 'rgba(255, 0, 0, 0.6)',
    borderColor: 'rgba(255, 0, 0, 1)'
  },
  'Libertarian': {
    backgroundColor: 'rgba(255, 211, 0, 0.6)',
    borderColor: 'rgba(255, 211, 0, 1)'
  },
  'Green': {
    backgroundColor: 'rgba(0, 128, 0, 0.6)',
    borderColor: 'rgba(0, 128, 0, 1)'
  },
  'Independent': {
    backgroundColor: 'rgba(128, 128, 128, 0.6)',
    borderColor: 'rgba(128, 128, 128, 1)'
  },
  'default': {
    backgroundColor: 'rgba(180, 180, 180, 0.6)',
    borderColor: 'rgba(180, 180, 180, 1)'
  }
};